import InstantApp from '../InstantApp'
import settings from './settings'
import customFields from './customFields'
import { LEAD_GEN } from '../../../constants/templateCategory'
import thumbnail from '../assets/thumbnail.jpg'

export const information = {
  id: 'fashionIcon',
  title: 'Dynamic Slider',
  image: thumbnail,
  thumbnailPath: ['scene2', 'bg'],
  category: LEAD_GEN,
  description: 'Capture users email and/or phone.',
  integrations: [],
  instantApp: InstantApp,
  defaultSettings: settings
}

export function getTemplate (app) {
  return {
    id: 'fashionIcon',
    customFields,
    settings
  }
}



// WEBPACK FOOTER //
// ./src/templates/fashionIcon/template/index.js